/* ========================================================================== 
   The Hope Tarot - single-screen One Free Question intake

   The visitor submits Name, Concern, Question, DOB and WhatsApp number once.
   Three distinct cards are selected automatically behind the scenes using the
   full 77-card, Death-free deck shared conceptually with the direct-WhatsApp
   workflow. They are not displayed in the UI or included in the customer's
   pre-filled WhatsApp message. The backend payload contract remains unchanged:
   cards[] and cardSummary are still supplied to /api/chat.
   ========================================================================== */
(function () {
  'use strict';

  if (window.THTTarotIntake && typeof window.THTTarotIntake.boot === 'function') {
    window.THTTarotIntake.boot(document);
    return;
  }

  var TAROT_DECK = [
    { n: 'The Fool', i: 'm00.jpg' },
    { n: 'The Magician', i: 'm01.jpg' },
    { n: 'The High Priestess', i: 'm02.jpg' },
    { n: 'The Empress', i: 'm03.jpg' },
    { n: 'The Emperor', i: 'm04.jpg' },
    { n: 'The Hierophant', i: 'm05.jpg' },
    { n: 'The Lovers', i: 'm06.jpg' },
    { n: 'The Chariot', i: 'm07.jpg' },
    { n: 'Strength', i: 'm08.jpg' },
    { n: 'The Hermit', i: 'm09.jpg' },
    { n: 'Wheel of Fortune', i: 'm10.jpg' },
    { n: 'Justice', i: 'm11.jpg' },
    { n: 'The Hanged Man', i: 'm12.jpg' },
    { n: 'Temperance', i: 'm14.jpg' },
    { n: 'The Devil', i: 'm15.jpg' },
    { n: 'The Tower', i: 'm16.jpg' },
    { n: 'The Star', i: 'm17.jpg' },
    { n: 'The Moon', i: 'm18.jpg' },
    { n: 'The Sun', i: 'm19.jpg' },
    { n: 'Judgement', i: 'm20.jpg' },
    { n: 'The World', i: 'm21.jpg' },
    { n: 'Ace of Cups', i: 'c01.jpg' },
    { n: 'Two of Cups', i: 'c02.jpg' },
    { n: 'Three of Cups', i: 'c03.jpg' },
    { n: 'Four of Cups', i: 'c04.jpg' },
    { n: 'Five of Cups', i: 'c05.jpg' },
    { n: 'Six of Cups', i: 'c06.jpg' },
    { n: 'Seven of Cups', i: 'c07.jpg' },
    { n: 'Eight of Cups', i: 'c08.jpg' },
    { n: 'Nine of Cups', i: 'c09.jpg' },
    { n: 'Ten of Cups', i: 'c10.jpg' },
    { n: 'Page of Cups', i: 'c11.jpg' },
    { n: 'Knight of Cups', i: 'c12.jpg' },
    { n: 'Queen of Cups', i: 'c13.jpg' },
    { n: 'King of Cups', i: 'c14.jpg' },
    { n: 'Ace of Swords', i: 's01.jpg' },
    { n: 'Two of Swords', i: 's02.jpg' },
    { n: 'Three of Swords', i: 's03.jpg' },
    { n: 'Four of Swords', i: 's04.jpg' },
    { n: 'Five of Swords', i: 's05.jpg' },
    { n: 'Six of Swords', i: 's06.jpg' },
    { n: 'Seven of Swords', i: 's07.jpg' },
    { n: 'Eight of Swords', i: 's08.jpg' },
    { n: 'Nine of Swords', i: 's09.jpg' },
    { n: 'Ten of Swords', i: 's10.jpg' },
    { n: 'Page of Swords', i: 's11.jpg' },
    { n: 'Knight of Swords', i: 's12.jpg' },
    { n: 'Queen of Swords', i: 's13.jpg' },
    { n: 'King of Swords', i: 's14.jpg' },
    { n: 'Ace of Wands', i: 'w01.jpg' },
    { n: 'Two of Wands', i: 'w02.jpg' },
    { n: 'Three of Wands', i: 'w03.jpg' },
    { n: 'Four of Wands', i: 'w04.jpg' },
    { n: 'Five of Wands', i: 'w05.jpg' },
    { n: 'Six of Wands', i: 'w06.jpg' },
    { n: 'Seven of Wands', i: 'w07.jpg' },
    { n: 'Eight of Wands', i: 'w08.jpg' },
    { n: 'Nine of Wands', i: 'w09.jpg' },
    { n: 'Ten of Wands', i: 'w10.jpg' },
    { n: 'Page of Wands', i: 'w11.jpg' },
    { n: 'Knight of Wands', i: 'w12.jpg' },
    { n: 'Queen of Wands', i: 'w13.jpg' },
    { n: 'King of Wands', i: 'w14.jpg' },
    { n: 'Ace of Pentacles', i: 'p01.jpg' },
    { n: 'Two of Pentacles', i: 'p02.jpg' },
    { n: 'Three of Pentacles', i: 'p03.jpg' },
    { n: 'Four of Pentacles', i: 'p04.jpg' },
    { n: 'Five of Pentacles', i: 'p05.jpg' },
    { n: 'Six of Pentacles', i: 'p06.jpg' },
    { n: 'Seven of Pentacles', i: 'p07.jpg' },
    { n: 'Eight of Pentacles', i: 'p08.jpg' },
    { n: 'Nine of Pentacles', i: 'p09.jpg' },
    { n: 'Ten of Pentacles', i: 'p10.jpg' },
    { n: 'Page of Pentacles', i: 'p11.jpg' },
    { n: 'Knight of Pentacles', i: 'p12.jpg' },
    { n: 'Queen of Pentacles', i: 'p13.jpg' },
    { n: 'King of Pentacles', i: 'p14.jpg' }
  ];

  function readConfig(sectionId) {
    var node = document.getElementById('tarot-reading-config-' + sectionId);
    if (!node) throw new Error('Missing tarot reading configuration for section ' + sectionId);
    return JSON.parse(node.textContent);
  }

  function initParticles(root) {
    var container = root.querySelector('[data-tht-stars]');
    if (!container || container.childElementCount) return;
    for (var i = 0; i < 20; i++) {
      var star = document.createElement('span');
      star.style.cssText = [
        'left:' + (Math.random() * 100) + '%',
        'top:' + (Math.random() * 100) + '%',
        'animation-delay:' + (Math.random() * 6) + 's',
        'animation-duration:' + (5 + Math.random() * 4) + 's'
      ].join(';');
      container.appendChild(star);
    }
  }

  function randomIndex(max) {
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      var values = new Uint32Array(1);
      var limit = Math.floor(4294967296 / max) * max;
      do { window.crypto.getRandomValues(values); } while (values[0] >= limit);
      return values[0] % max;
    }
    return Math.floor(Math.random() * max);
  }

  function drawThreeCards() {
    var pool = TAROT_DECK.slice();
    var selected = [];
    for (var i = 0; i < 3; i++) {
      selected.push(pool.splice(randomIndex(pool.length), 1)[0]);
    }
    return selected;
  }

  function initSection(root) {
    if (!root || root.dataset.thtReadingInitialized === 'true') return;

    var config = readConfig(root.dataset.sectionId);
    var sid = String(config.sectionId);
    var form = document.getElementById('tr-form-' + sid);
    var formStatus = document.getElementById('tr-form-status-' + sid);
    var submitButton = form && form.querySelector('.tr-phase-next');
    var businessWhatsApp = String(config.businessWhatsApp || '').replace(/\D/g, '');
    var selectedDeck = [];
    var queueNo = null;
    var submitted = false;

    if (!form || !submitButton) {
      throw new Error('Tarot intake markup is incomplete for section ' + sid);
    }

    root.dataset.thtReadingInitialized = 'true';
    initParticles(root);
    initConcern();
    initPhone();
    initWheels();

    function setFormStatus(message) {
      if (formStatus) formStatus.textContent = message || '';
    }

    function goTo(name) {
      root.querySelectorAll('.tr-screen').forEach(function (screen) {
        screen.classList.toggle('tr-screen--active', screen.dataset.screen === name);
      });
    }

    function flagError(id, triggerId) {
      var field = document.getElementById(id + '-' + sid);
      var target = triggerId ? document.getElementById(triggerId + '-' + sid) : field;
      if (!target) return;
      target.classList.add('tr-input--error');
      var watch = field || target;
      var clear = function () {
        target.classList.remove('tr-input--error');
        setFormStatus('');
        watch.removeEventListener('input', clear);
        watch.removeEventListener('change', clear);
      };
      watch.addEventListener('input', clear);
      watch.addEventListener('change', clear);
    }

    function validateForm() {
      var missing = [];
      var fields = [
        { id: 'tr-name', label: 'Name' },
        { id: 'tr-concern', label: 'Concern', trigger: 'tr-concern-trigger' },
        { id: 'tr-question', label: 'Your Question' },
        { id: 'tr-dob', label: 'Date of Birth', trigger: 'tr-dobwheels' }
      ];

      fields.forEach(function (definition) {
        var input = document.getElementById(definition.id + '-' + sid);
        if (!input || !String(input.value || '').trim()) {
          missing.push(definition.label);
          flagError(definition.id, definition.trigger);
        }
      });

      var dobInput = document.getElementById('tr-dob-' + sid);
      var dob = dobInput ? String(dobInput.value || '') : '';
      if (dob && !/^\d{4}-\d{2}-\d{2}$/.test(dob)) {
        flagError('tr-dob', 'tr-dobwheels');
        setFormStatus('Please enter a valid date of birth.');
        return false;
      }

      var phoneInput = document.getElementById('tr-phone-' + sid);
      var phoneDigits = phoneInput ? String(phoneInput.value || '').replace(/\D/g, '') : '';
      if (phoneDigits.length !== 10) {
        missing.push('WhatsApp Number');
        flagError('tr-phone');
        var phonePop = document.getElementById('tr-phone-pop-' + sid);
        if (phonePop) {
          phonePop.hidden = false;
          clearTimeout(phonePop._timer);
          phonePop._timer = setTimeout(function () { phonePop.hidden = true; }, 2600);
        }
      }

      if (missing.length) {
        setFormStatus('Please fill in: ' + missing.join(', '));
        return false;
      }
      return true;
    }

    function readForm() {
      function value(id) {
        var element = document.getElementById(id + '-' + sid);
        return element ? String(element.value || '').trim() : '';
      }
      var countryCode = value('tr-cc').replace(/\D/g, '') || '91';
      var localPhone = value('tr-phone').replace(/\D/g, '');
      return {
        name: value('tr-name'),
        concern: value('tr-concern'),
        question: value('tr-question'),
        dob: value('tr-dob'),
        phone: localPhone ? countryCode + localPhone : ''
      };
    }

    function buildWhatsAppLink() {
      var details = readForm();
      var message = [
        "Here's my information for the one free question.",
        'Name: ' + (details.name || 'Not provided'),
        'Date of Birth: ' + (details.dob || 'Not provided'),
        'Ph. No: ' + (details.phone || 'Not provided'),
        'Concern: ' + (details.concern || 'Not provided'),
        'Question: ' + (details.question || 'Not provided')
      ].join('\n');
      return 'https://wa.me/' + businessWhatsApp + '?text=' + encodeURIComponent(message);
    }

    function renderQueue() {
      var box = document.getElementById('tr-queue-info-' + sid);
      var message = document.getElementById('tr-queue-message-' + sid);
      var eta = document.getElementById('tr-queue-eta-' + sid);
      if (message) message.textContent = 'You are number ' + queueNo + " in today's reading queue.";
      if (eta) eta.textContent = 'Send the WhatsApp message now — your personalised reading from Dr. Sneha Jain arrives within 15–30 minutes.';
      if (box) box.hidden = false;
    }

    function sendLeadToBackend() {
      try {
        var sessionId = 'reading-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
        var details = readForm();
        var cardSummary = selectedDeck.map(function (card, index) {
          return (index + 1) + '. ' + card.n;
        }).join(', ');
        var fullMessage = [
          'Free Question Lead Submission:',
          '• Name: ' + (details.name || 'Not provided'),
          '• Date of Birth: ' + (details.dob || 'Not provided'),
          '• Phone / WhatsApp: ' + (details.phone || 'Not provided'),
          '• Concern: ' + (details.concern || 'Not provided'),
          '• Question: ' + (details.question || 'General reading'),
          '• Automatically selected cards: ' + cardSummary
        ].join('\n');
        var apiEndpoint = (window.THT_BACKEND_ENDPOINT || 'https://the-hope-tarot-chatbot.vercel.app').replace(/\/$/, '');

        fetch(apiEndpoint + '/api/chat', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            sessionId: sessionId,
            message: fullMessage,
            phone: details.phone || null,
            name: details.name || null,
            dob: details.dob || null,
            question: details.question || null,
            concern: details.concern || null,
            queueNumber: queueNo,
            cards: selectedDeck.map(function (card) { return { n: card.n, i: card.i }; }),
            cardSummary: cardSummary,
            consent: true,
            visitCount: 1,
            context: {
              sourcePage: window.location.pathname,
              pageType: 'tarot-reading',
              referrer: document.referrer ? (function () {
                try { return new URL(document.referrer).hostname; } catch (error) { return ''; }
              })() : ''
            }
          })
        }).then(function (response) {
          return response.json();
        }).then(function (data) {
          console.log('[THT Reading] Lead saved:', data);
          if (!data || !data.blocked) return;

          var queue = document.getElementById('tr-queue-info-' + sid);
          var claimed = document.getElementById('tr-claimed-info-' + sid);
          var heading = document.getElementById('tr-final-heading-' + sid);
          var check = document.getElementById('tr-final-check-' + sid);
          var whatsApp = document.getElementById('tr-wa-btn-' + sid);
          if (queue) queue.hidden = true;
          if (whatsApp) whatsApp.hidden = true;
          if (claimed) {
            claimed.hidden = false;
            var badge = claimed.querySelector('.tr-claimed-badge');
            var sub = claimed.querySelector('.tr-claimed-sub');
            if (badge) badge.textContent = 'Important';
            if (sub) sub.textContent = '';
          }
          if (check) check.textContent = '♡';
          if (heading) heading.textContent = 'About your question';
          var blockedMessage = document.getElementById('tr-claimed-message-' + sid);
          if (blockedMessage) blockedMessage.textContent = data.reply || '';
        }).catch(function (error) {
          console.error('[THT Reading] API call failed:', error);
        });
      } catch (error) {
        console.error('[THT Reading] Send lead error:', error);
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (submitted || !validateForm()) return;

      submitted = true;
      selectedDeck = drawThreeCards();
      queueNo = 90 + randomIndex(61);
      submitButton.disabled = true;
      submitButton.textContent = 'Opening WhatsApp…';

      var whatsAppLink = buildWhatsAppLink();
      sendLeadToBackend();
      renderQueue();

      var whatsAppButton = document.getElementById('tr-wa-btn-' + sid);
      if (whatsAppButton) {
        whatsAppButton.href = whatsAppLink;
        whatsAppButton.hidden = false;
      }
      goTo('final');
      window.open(whatsAppLink, '_blank');
    });

    function initPhone() {
      var localPhone = document.getElementById('tr-phone-' + sid);
      if (!localPhone) return;
      localPhone.addEventListener('input', function () {
        var digits = localPhone.value.replace(/\D/g, '').slice(0, 10);
        if (localPhone.value !== digits) localPhone.value = digits;
      });
    }

    function initConcern() {
      var wrapper = document.getElementById('tr-concern-wrap-' + sid);
      if (!wrapper) return;
      var trigger = document.getElementById('tr-concern-trigger-' + sid);
      var menu = document.getElementById('tr-concern-menu-' + sid);
      var hidden = document.getElementById('tr-concern-' + sid);
      var text = trigger.querySelector('.tr-select-text');
      var options = Array.prototype.slice.call(menu.querySelectorAll('.tr-select-option'));
      var activeIndex = -1;

      function isOpen() { return !menu.hidden; }
      function close() {
        if (!isOpen()) return;
        menu.hidden = true;
        wrapper.classList.remove('tr-select--open');
        trigger.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', onDocumentClick, true);
      }
      function onDocumentClick(event) { if (!wrapper.contains(event.target)) close(); }
      function setActive(index) {
        if (index < 0 || index >= options.length) return;
        options.forEach(function (option) { option.classList.remove('tr-select-option--active'); });
        activeIndex = index;
        options[index].classList.add('tr-select-option--active');
        options[index].scrollIntoView({ block: 'nearest' });
      }
      function open() {
        if (isOpen()) return;
        menu.hidden = false;
        wrapper.classList.add('tr-select--open');
        trigger.setAttribute('aria-expanded', 'true');
        setActive(activeIndex >= 0 ? activeIndex : 0);
        document.addEventListener('click', onDocumentClick, true);
      }
      function choose(option) {
        hidden.value = option.getAttribute('data-value');
        text.textContent = option.textContent;
        text.classList.remove('tr-select-placeholder');
        options.forEach(function (candidate) {
          var selected = candidate === option;
          candidate.setAttribute('aria-selected', selected ? 'true' : 'false');
          candidate.classList.toggle('tr-select-option--selected', selected);
        });
        trigger.classList.remove('tr-input--error');
        setFormStatus('');
        close();
        trigger.focus();
      }

      trigger.addEventListener('click', function () { isOpen() ? close() : open(); });
      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { close(); return; }
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          if (!isOpen()) open(); else setActive(Math.min(activeIndex + 1, options.length - 1));
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          if (isOpen()) setActive(Math.max(activeIndex - 1, 0));
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          if (isOpen() && activeIndex >= 0) choose(options[activeIndex]); else open();
        }
      });
      options.forEach(function (option, index) {
        option.addEventListener('click', function () { choose(option); });
        option.addEventListener('mousemove', function () { setActive(index); });
      });
    }

    function initWheels() {
      var rootWheels = document.getElementById('tr-dobwheels-' + sid);
      if (!rootWheels) return;
      var hiddenDob = document.getElementById('tr-dob-' + sid);
      var rowHeight = 32;
      var touched = false;
      var state = { day: 1, month: 0, year: 2000 };
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

      function pad(value) { return (value < 10 ? '0' : '') + value; }
      function daysInMonth(month, year) { return new Date(year, month + 1, 0).getDate(); }
      function writeDob() {
        if (!touched) return;
        hiddenDob.value = state.year + '-' + pad(state.month + 1) + '-' + pad(state.day);
        rootWheels.classList.remove('tr-input--error');
        setFormStatus('');
      }

      function makeWheel(element, onChange) {
        var track = element.querySelector('.tr-wheel-track');
        var values = [];
        var current = -1;
        var timer;
        function selectedIndex() {
          return Math.max(0, Math.min(values.length - 1, Math.round(element.scrollTop / rowHeight)));
        }
        function highlight(index) {
          Array.prototype.forEach.call(track.children, function (cell, cellIndex) {
            cell.classList.toggle('is-selected', cellIndex === index);
          });
        }
        function settle(fire) {
          var index = selectedIndex();
          highlight(index);
          if (index !== current) {
            current = index;
            if (fire && values[index]) onChange(values[index].value);
          }
        }
        function setIndex(index, fire) {
          index = Math.max(0, Math.min(values.length - 1, index));
          element.scrollTop = index * rowHeight;
          current = -1;
          settle(fire);
        }
        function setValues(nextValues, selected) {
          values = nextValues;
          track.innerHTML = values.map(function (value) {
            return '<li class="tr-wheel-cell">' + value.label + '</li>';
          }).join('');
          setIndex(selected || 0, false);
        }
        element.addEventListener('scroll', function () {
          highlight(selectedIndex());
          clearTimeout(timer);
          timer = setTimeout(function () { settle(true); }, 90);
        }, { passive: true });
        element.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowDown') { event.preventDefault(); setIndex(selectedIndex() + 1, true); }
          if (event.key === 'ArrowUp') { event.preventDefault(); setIndex(selectedIndex() - 1, true); }
        });
        track.addEventListener('click', function (event) {
          var cell = event.target && event.target.closest ? event.target.closest('.tr-wheel-cell') : null;
          if (cell) setIndex(Array.prototype.indexOf.call(track.children, cell), true);
        });
        return { setValues: setValues };
      }

      ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (eventName) {
        rootWheels.addEventListener(eventName, function () { touched = true; writeDob(); }, { passive: true });
      });

      var dayWheel = makeWheel(rootWheels.querySelector('[data-wheel="day"]'), function (value) {
        state.day = value;
        writeDob();
      });
      var monthWheel = makeWheel(rootWheels.querySelector('[data-wheel="month"]'), function (value) {
        state.month = value;
        refreshDays();
        writeDob();
      });
      var yearWheel = makeWheel(rootWheels.querySelector('[data-wheel="year"]'), function (value) {
        state.year = value;
        refreshDays();
        writeDob();
      });

      function refreshDays() {
        var count = daysInMonth(state.month, state.year);
        if (state.day > count) state.day = count;
        var days = [];
        for (var day = 1; day <= count; day++) days.push({ value: day, label: String(day) });
        dayWheel.setValues(days, state.day - 1);
      }

      var latestBirthYear = new Date().getFullYear() - 18;
      var years = [];
      var selectedYearIndex = 0;
      for (var year = latestBirthYear; year >= 1920; year--) {
        if (year === state.year) selectedYearIndex = years.length;
        years.push({ value: year, label: String(year) });
      }
      monthWheel.setValues(months.map(function (month, index) {
        return { value: index, label: month };
      }), state.month);
      yearWheel.setValues(years, selectedYearIndex);
      refreshDays();
    }
  }

  function boot(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches('[data-tht-tarot-reading]')) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-tht-tarot-reading]')));
    }
    roots.forEach(function (root) {
      try {
        initSection(root);
      } catch (error) {
        root.removeAttribute('data-tht-reading-initialized');
        console.error('[THT Reading] Initialization failed:', error);
      }
    });
  }

  window.THTTarotIntake = { boot: boot };
  boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();
